<template>
  <div class="game-list-page">
    <!-- Keep the existing profile request flow mounted without rendering its legacy header. -->
    <Header class="game-list-legacy-header"></Header>

    <header class="game-list-header">
      <button class="game-list-back" type="button" :aria-label="$t('Back')" @click="back">
        <img src="../../static/images/livequiz/back.png" alt="">
      </button>
      <img class="game-list-title" src="../../static/images/game/brain_games_title.png" :alt="$t('homeGame1T')">
    </header>

    <main class="game-list-content">
      <section class="game-list-grid" :aria-label="$t('homeGame1T')">
        <p v-if="gameList && gameList.length === 0" class="game-list-empty">
          {{$t('NoGameList')}}
        </p>
        <article
          v-for="(item, index) in gameList"
          v-else
          :key="item.game_id || index"
          class="game-list-card"
          role="button"
          tabindex="0"
          @click="goBattleRoom(item.game_id)"
          @keydown.enter="goBattleRoom(item.game_id)"
        >
          <img class="game-list-cover" :src="item.cover_image" :alt="item.title">
          <div class="game-list-card-body">
            <h2>{{item.title}}</h2>
            <button type="button" @click.stop="goBattleRoom(item.game_id)">
              <img class="game-list-play-bg" src="../../static/images/game/play_btn.png" alt="">
              <span>{{$t('play')}}<img src="../../static/images/game/play.png" alt=""></span>
            </button>
          </div>
        </article>
      </section>
    </main>
  </div>
</template>

<script>
import Header from '../components/HeaderPoint'
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data () {
    return {
      isShow: null,
      info: {},
      redeemInfo: {},
      gameList: null
    }
  },
  created () {
    this.getRedeem()
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    getRedeem () {
      const that = this
      that.$parent.loadModal(true)
      that.$api.post('/api/game/list', null, r => {
        that.gameList = r.data
        that.$parent.loadModal(false)
      })
    },
    goBattleRoom (item) {
      this.$router.push({ path: '/gameIframe', query: { game_id: item } })
    }
  }
}
</script>

<style scoped>
.game-list-page { position:relative; min-height:100vh; box-sizing:border-box; overflow-x:hidden; padding:46px 28px 44px; color:#fff; background:#06021d url('../../static/images/livequiz/main_bg.jpg') center top/100% 100% no-repeat; font-family:Arial,Atom-sans,sans-serif; }
.game-list-page::before { position:absolute; z-index:0; inset:0; content:''; background:rgba(7,0,26,.16); pointer-events:none; }
.game-list-legacy-header { display:none; }
.game-list-header,.game-list-content { position:relative; z-index:1; width:100%; max-width:650px; margin:0 auto; }
.game-list-header { display:block; min-height:174px; }
.game-list-back { position:absolute; z-index:1; top:0; left:0; display:flex; width:72px; height:72px; align-items:center; justify-content:center; margin-top:0; padding:0; border:0; background:transparent; cursor:pointer; }
.game-list-back img { display:block; width:100%; height:100%; object-fit:contain; }
.game-list-title { display:block; width:min(100%,650px); margin:24px auto 0; object-fit:contain; }
.game-list-content { padding-top:86px; }
.game-list-grid { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:22px 18px; align-items:start; }
.game-list-empty { grid-column:1 / -1; margin:0; padding:120px 0; color:#fff; font-size:clamp(18px,5vw,30px); font-weight:700; text-align:center; }
.game-list-card { overflow:hidden; border:3px solid #fa278f; border-radius:36px; background:#2b062a; box-shadow:inset 0 -2px 0 rgba(255,189,49,.75),0 7px 14px rgba(0,0,0,.18); cursor:pointer; outline:0; }
.game-list-card:focus-visible { outline:3px solid #fff; outline-offset:3px; }
.game-list-cover { display:block; width:100%; aspect-ratio:16 / 9; object-fit:cover; }
.game-list-card-body { display:flex; min-height:clamp(148px,34vw,220px); align-items:center; flex-direction:column; justify-content:space-evenly; padding:6% 5% 7%; box-sizing:border-box; background:rgba(58,3,47,.88); }
.game-list-card h2 { display:flex; min-height:2.1em; align-items:center; justify-content:center; margin:0; color:#fff; font-size:clamp(17px,4.8vw,32px); font-weight:900; line-height:1.04; text-align:center; text-shadow:0 3px 3px rgba(12,0,22,.82); text-transform:uppercase; }
.game-list-card button { position:relative; display:block; width:72%; margin:2% 0 0; padding:0; border:0; background:transparent; cursor:pointer; }
.game-list-play-bg { display:block; width:100%; }
.game-list-card button span { position:absolute; top:51%; right:6%; left:6%; display:flex; align-items:center; justify-content:center; gap:5px; transform:translateY(-50%); color:#fff; font-size:clamp(16px,4.4vw,30px); font-weight:900; line-height:1; text-shadow:0 3px 2px rgba(63,0,42,.78); text-transform:uppercase; }
.game-list-card button span img { display:block; width:auto; height:clamp(13px,3.5vw,24px); object-fit:contain; }

@media (max-width:520px) {
  .game-list-page { padding:30px 18px 36px; }
  .game-list-header { min-height:200px; }
  .game-list-back { width:52px; height:52px; }
  .game-list-content { padding-top:64px; }
  .game-list-grid { gap:16px 14px; }
  .game-list-card { border-width:2px; border-radius:25px; }
}
</style>



// WEBPACK FOOTER //
// src/page/gameList.vue